import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Box, Button, Divider, Grid } from "@mui/material";
import LoadingWrapper from "components/Shared/LoadingWrapper";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";

const INITIAL_STATE = {
  name: "",
  code: "",
};

const WardForm = ({
  wardDetail = null,
  municipalityDetail,
  isBusy = false,
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  // react form hook
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: INITIAL_STATE,
  });

  const handleSubmitWard = (data) => {
    let updatedMunicipalityDetail;

    if (wardDetail) {
      updatedMunicipalityDetail = {
        ...municipalityDetail,
        wards: municipalityDetail.wards.map((ward) =>
          ward._id === wardDetail._id ? { ...ward, ...data } : ward
        ),
      };
    } else {
      updatedMunicipalityDetail = {
        ...municipalityDetail,
        wards: municipalityDetail.wards
          ? [...municipalityDetail.wards, data]
          : [data],
      };
    }

    onSubmit(updatedMunicipalityDetail);
  };

  React.useEffect(() => {
    if (!municipalityDetail) {
      reset(INITIAL_STATE);
    } else {
      reset({ ...wardDetail });
    }
  }, [municipalityDetail, wardDetail, reset]);

  return (
    <LoadingWrapper loading={isBusy}>
      <InnerShadowBox padding={3}>
        <Grid container spacing={5}>
          <Grid item md={12}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Ward name is required" }}
              render={({ field }) => (
                <BaseTextField
                  fullWidth
                  label="Ward Name"
                  type="text"
                  size="small"
                  {...field}
                />
              )}
            />
            {errors.name && <p className="error">{errors.name.message}</p>}
          </Grid>

          <Grid item md={12}>
            <Controller
              name="code"
              control={control}
              rules={{ required: "Ward code is required" }}
              render={({ field }) => (
                <BaseTextField
                  fullWidth
                  label="Ward Code"
                  type="text"
                  size="small"
                  {...field}
                />
              )}
            />
            {errors.code && <p className="error">{errors.code.message}</p>}
          </Grid>
        </Grid>
      </InnerShadowBox>

      <Divider />

      <Box
        paddingX={3}
        paddingY={2}
        gap={2}
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button disabled={isBusy} onClick={onCancel}>
          Cancel
        </Button>

        <Button
          variant="outlined"
          disabled={isBusy}
          onClick={handleSubmit(handleSubmitWard)}
        >
          {!wardDetail ? "Add" : "Update"}
        </Button>
      </Box>
    </LoadingWrapper>
  );
};

export default WardForm;
